
export const firstDailyPuzzleYear = 2025;
export const firstDailyPuzzleMonth = 11;
export const firstDailyPuzzleDay = 6;